import { render, staticRenderFns } from "./DateMealPiliangbaoting.vue?vue&type=template&id=0094dc89&scoped=true&"
import script from "./DateMealPiliangbaoting.vue?vue&type=script&lang=js&"
export * from "./DateMealPiliangbaoting.vue?vue&type=script&lang=js&"
import style0 from "./DateMealPiliangbaoting.vue?vue&type=style&index=0&id=0094dc89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0094dc89",
  null
  
)

export default component.exports